import type { AvatarId } from "@nano/contracts";

/**
 * Character families shown as groups in the picker. Every family offers a
 * boy and a girl (or a matched pair), so nobody has to play the other gender.
 */
export interface ArchetypeFamily {
  readonly id: string;
  readonly name: string;
  readonly members: readonly AvatarId[];
}

export const ARCHETYPE_FAMILIES: readonly ArchetypeFamily[] = [
  { id: "mage", name: "Pháp Sư", members: ["wizard", "sorceress"] },
  { id: "fairytale", name: "Cổ Tích", members: ["princess", "prince"] },
  { id: "divine", name: "Thần Thánh", members: ["angel-boy", "angel-girl", "demon-boy", "demon-girl"] },
];
